import React from 'react'

const LeaseEquipment = ({fill}) => {
  return (
    <svg
      width="90"
      height="90"
      viewBox={fill ? "0 4 80 80":"0 0 90 90"}
      fill={"none" || fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="noun-drilling-machines-5290277 1" opacity="1">
        <g id="Group 1000003879" opacity="1">
          <path
            id="Vector"
            d="M62.0798 75C68.7251 75 74.1121 69.613 74.1121 62.9678C74.1121 56.3226 68.7251 50.9355 62.0798 50.9355C55.4346 50.9355 50.0476 56.3226 50.0476 62.9678C50.0476 69.613 55.4346 75 62.0798 75Z"
            stroke={fill ? fill : "#211E24"}
            stroke-width="2"
            stroke-miterlimit="10"
            stroke-linecap="round"
          />
          <path
            id="Vector_2"
            d="M62.1074 56.884V63.2362L67.2312 67.1293"
            stroke={fill ? fill : "#211E24"}
            stroke-width="2"
            stroke-miterlimit="10"
            stroke-linecap="round"
          />
          <g id="Group">
            <path
              id="Vector_3"
              d="M50.2359 59.9891C48.256 57.6679 46.4959 57.0458 45.2406 56.915C42.9544 56.6767 41.6485 57.9955 37.8757 58.9004C35.7845 59.4018 34.0029 59.5201 32.8163 59.5408C31.7451 59.7233 30.9884 60.6573 31.0231 61.6542C31.0622 62.7776 32.0973 63.7279 33.3287 63.6396H43.7677"
              stroke={fill ? fill : "#211E24"}
              stroke-width="2"
              stroke-miterlimit="10"
              stroke-linecap="round"
            />
            <path
              id="Vector_4"
              d="M30.8797 61.3339L20.0544 55.6781L19.2567 55.2251C18.068 54.4996 16.5897 54.9325 16.0858 55.8903C15.6379 56.7413 15.955 58.0146 16.9823 58.7082C22.1058 61.889 27.2292 65.0698 32.3526 68.2506L34.6007 69.4909C35.5632 70.0219 36.6427 70.305 37.7418 70.3145C42.0936 70.3523 48.0183 70.3902 52.3701 70.428"
              stroke={fill ? fill : "#211E24"}
              stroke-width="2"
              stroke-miterlimit="10"
              stroke-linecap="round"
            />
          </g>
          <g id="Group_2">
            <path
              id="Vector_5"
              d="M57.346 28.6973C56.3311 28.599 55.3201 28.4599 54.3066 28.3467C54.0848 28.3219 53.9608 28.2213 53.8844 28.0108C53.7557 27.656 53.6213 27.3003 53.45 26.965C53.3242 26.7188 53.3712 26.5501 53.5339 26.3478C54.1663 25.5616 54.7854 24.7647 55.407 23.9699C56.0109 23.1977 55.97 22.4486 55.2825 21.7583C54.2222 20.6937 53.1597 19.6314 52.0955 18.5707C51.3912 17.8686 50.6472 17.8327 49.8583 18.4536C49.0565 19.0847 48.2503 19.7106 47.4532 20.3477C47.2788 20.4871 47.1276 20.513 46.9231 20.4142C46.5937 20.2551 46.258 20.1018 45.9111 19.9884C45.6291 19.8964 45.5182 19.7412 45.4882 19.4482C45.3847 18.4337 45.2619 17.4209 45.1308 16.4094C45.0139 15.5072 44.429 15.0025 43.5221 15.0013C42.0081 14.9992 40.4942 15 38.9802 15.001C37.9945 15.0016 37.4201 15.5218 37.3099 16.4974C37.1953 17.5109 37.0684 18.523 36.9551 19.5366C36.9304 19.7575 36.8329 19.8828 36.621 19.9595C36.2663 20.088 35.912 20.2256 35.5761 20.396C35.3317 20.5199 35.1616 20.4774 34.9581 20.3135C34.1632 19.6737 33.3575 19.0473 32.553 18.4196C31.813 17.8422 31.0568 17.885 30.3939 18.5375C30.1488 18.7789 27.3703 21.5587 27.1943 21.7362C26.4738 22.463 26.4351 23.1895 27.0709 23.9983C27.6945 24.7915 28.3129 25.5888 28.9428 26.377C29.0884 26.5592 29.1279 26.7163 29.0182 26.9362C28.855 27.2633 28.7057 27.601 28.5915 27.9478C28.5029 28.2165 28.3555 28.3264 28.0768 28.3555C27.0626 28.4615 26.05 28.5846 25.038 28.7115C24.1182 28.8269 23.6105 29.4095 23.6095 30.3372C23.6077 31.8397 23.6085 33.3421 23.6092 34.8446C23.6096 35.8677 24.1337 36.4319 25.1537 36.5413C26.1563 36.6487 27.1565 36.7789 28.1585 36.8926C28.3647 36.916 28.4874 37.0079 28.5614 37.2051C28.6979 37.5693 28.8388 37.9335 29.0086 38.2828C29.12 38.512 29.0926 38.6763 28.9353 38.872C28.3101 39.6492 27.7009 40.4392 27.0839 41.223C26.4319 42.0512 26.468 42.7731 27.2043 43.5105C28.2497 44.5575 29.2956 45.604 30.343 46.649C31.0663 47.3707 31.8003 47.4101 32.6054 46.7768C33.3985 46.1531 34.1958 45.5345 34.984 44.9047C35.1652 44.7599 35.3221 44.7179 35.543 44.8252C35.8925 44.995 36.2538 45.144 36.6195 45.2754C36.8494 45.3581 36.9328 45.5025 36.9586 45.7326C37.0621 46.655 37.2181 47.5734 37.2792 48.4982C37.3349 49.3421 37.6762 49.9319 38.4743 50.2373H43.98C44.7946 49.927 45.1226 49.3156 45.179 48.4657C45.2397 47.553 45.3949 46.6468 45.4945 45.7362C45.5218 45.4875 45.6224 45.3488 45.8634 45.2661C46.2198 45.1437 46.5717 45.0009 46.909 44.8335C47.1281 44.7248 47.2817 44.7528 47.4663 44.9006C48.2531 45.531 49.0508 46.1476 49.8426 46.7718C50.6577 47.4145 51.3892 47.3726 52.1295 46.6334C53.1676 45.597 54.2051 44.5598 55.2413 43.5214C55.9804 42.7809 56.0233 42.0516 55.3807 41.2341C54.7577 40.4414 54.1394 39.6449 53.5095 38.8577C53.363 38.6746 53.3307 38.5179 53.4372 38.2988C53.6068 37.9496 53.7517 37.5872 53.8858 37.2225C53.9633 37.0115 54.0902 36.9154 54.3107 36.8908C55.3235 36.7777 56.3337 36.639 57.3478 36.5403C58.1084 36.4662 58.5721 36.0506 58.8455 35.3718V29.8661C58.572 29.1862 58.1076 28.771 57.346 28.6973Z"
              stroke={fill ? fill : "#211E24"}
              stroke-width="2"
              stroke-miterlimit="10"
              stroke-linecap="round"
            />
            <path
              id="Vector_6"
              d="M41.2269 40.6705C45.6738 40.6705 49.2787 37.0655 49.2787 32.6186C49.2787 28.1717 45.6738 24.5668 41.2269 24.5668C36.78 24.5668 33.175 28.1717 33.175 32.6186C33.175 37.0655 36.78 40.6705 41.2269 40.6705Z"
              stroke={fill ? fill : "#211E24"}
              stroke-width="2"
              stroke-miterlimit="10"
              stroke-linecap="round"
            />
            <path
              id="Vector_7"
              d="M41.227 34.8659C42.4681 34.8659 43.4743 33.8598 43.4743 32.6186C43.4743 31.3775 42.4681 30.3713 41.227 30.3713C39.9859 30.3713 38.9797 31.3775 38.9797 32.6186C38.9797 33.8598 39.9859 34.8659 41.227 34.8659Z"
              stroke={fill ? fill : "#211E24"}
              stroke-width="2"
              stroke-miterlimit="10"
              stroke-linecap="round"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default LeaseEquipment

